export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        registration.update().catch(() => {});
      })
      .catch((error) => {
        console.error("Servis worker kaydedilemedi:", error);
      });
  });
}
